// @flow
import EnteringIdentifier, { type CheckResult } from './entering-identifier';

export default EnteringIdentifier;
export type { CheckResult };
